skrilla.controller('moveUserToCustomerReferralCtrl', function ($scope, cacheService, searchService, modalService) {
    $scope.userId = cacheService.getObject("moveUserToCustomerReferral");
    $scope.promotions = cacheService.getObjectOrElse("promotionsTable", []);

    searchService.get("promotions/definitions?purposes=PROMOTION").then(function(response){
        $scope.definitions = response.data.result;
    })

    $scope.moveToExisting = function(promotion){
        modalService.confirm("Are you sure'd you like to change this user's referral to this " + promotion.name + " promotion?", function(){
            searchService.put("users/" + $scope.userId + "/promotion/existingDefinition/" + promotion.id, {}, "Successfully updated user referral").then(function(response){
                modalService.dismissAll()
            });
        })
    }

});
